import { render, staticRenderFns } from "./PlatformOrganization.vue?vue&type=template&id=605763bd&scoped=true"
import script from "./PlatformOrganization.vue?vue&type=script&lang=js"
export * from "./PlatformOrganization.vue?vue&type=script&lang=js"
import style0 from "./PlatformOrganization.vue?vue&type=style&index=0&id=605763bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605763bd",
  null
  
)

export default component.exports